import { render, staticRenderFns } from "./engagement-content.vue?vue&type=template&id=8db237d4&scoped=true&"
import script from "./engagement-content.vue?vue&type=script&lang=js&"
export * from "./engagement-content.vue?vue&type=script&lang=js&"
import style0 from "./engagement-content.vue?vue&type=style&index=0&id=8db237d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db237d4",
  null
  
)

component.options.__file = "engagement-content.vue"
export default component.exports